import request from '../../utils/request'
import store from '../../store/index'

// 获取AK/SK列表
export const getAKSK = (info) => {
  return request({
    url: '/admin-getAKSKList',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      ...info
    }
  })
}
// 创建AK/SK
export const addAKSK = (info) => {
  return request({
    url: '/admin-createAKSK',
    method: 'post',
    data: {
      ...info
    }
  })
}
// 查看Secret
export const getSecret = (info) => {
  return request({
    url: '/admin-getAKSKSecretKey',
    method: 'get',
    params: {
      ...info
    }
  })
}
// 编辑AK/SK
export const editAKSK = (info) => {
  return request({
    url: '/admin-updateAKSK',
    method: 'post',
    data: {
      ...info
    }
  })
}
// 删除AK/SK
export const delAKSK = (info) => {
  return request({
    url: '/admin-deleteAKSK',
    method: 'post',
    data: {
      ...info
    }
  })
}